import { render, staticRenderFns } from "./EditPhone.vue?vue&type=template&id=4b155fc6&scoped=true&"
import script from "./EditPhone.vue?vue&type=script&lang=js&"
export * from "./EditPhone.vue?vue&type=script&lang=js&"
import style0 from "./EditPhone.vue?vue&type=style&index=0&id=4b155fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b155fc6",
  null
  
)

export default component.exports